module.exports = __webpack_public_path__ + "img/plus_btn.6a6f11d0.png";